/***********************************************************************
Use            : Wrapper class to handle the http calls
Created By     : ATP-0000850
Created Date   : 13-APR-2020
Updated By     : ATP-0000850
Updated Date   : 13-APR-2020
***********************************************************************/
import axios from 'axios';
import AuthService from '@/services/auth.service';
const auth = new AuthService();

// set base URL from the env
axios.defaults.baseURL = process.env.VUE_APP_API_Base_URL;

export class http {
    // #. http methods..

    static get(url: string): any {
        return auth.isLoggedIn().then((isLoggedIn) => {
            if (isLoggedIn) {
                return auth.getAccessToken().then((userToken: string) => {
                    const headers = {
                        'Authorization': `Bearer ${userToken}`,
                        'Accept-Language': localStorage.getItem("language") || "en-US"
                    };

                    headers['RemoteUrl'] = window.location.href.split('#')[0];

                    return axios.get(url, { headers })
                        .then(response => {
                            return response;
                        })
                        .catch(e => {
                            if (e.response.status === 401 || e.response.status === 403) {
                                if (window.location.pathname != "/Unauthorized")
                                    window.location.href = "/Unauthorized";

                                return Promise.resolve(e.response);
                            } else {
                                return Promise.reject(e);
                            }
                        });
                });
            } else {
                const headers = {
                    'Accept-Language': localStorage.getItem("language") || "en-US"
                };
                return axios.get(url, { headers })
                    .then(response => {
                        return response;
                    })
                    .catch(e => {
                        if (e.response.status === 401 || e.response.status === 403) {
                            if (window.location.pathname != "/Unauthorized")
                                window.location.href = "/Unauthorized";

                            return Promise.resolve(e.response);
                        } else {
                            return Promise.reject(e);
                        }
                    });
            }
        });
    }

    static post(url: string, data: any, contentType?: string) {
        return auth.isLoggedIn().then((isLoggedIn) => {
            if (isLoggedIn) {
                return auth.getAccessToken().then((userToken: string) => {
                    const headers = {
                        'Authorization': `Bearer ${userToken}`,
                        'Content-Type': contentType ? contentType : 'application/json',
                        'Accept-Language': localStorage.getItem("language") || "en-US"
                    };

                    headers['RemoteUrl'] = window.location.href.split('#')[0];

                    return axios.post(url, data, { headers });
                });
            } else {
                const headers = {
                    'Content-Type': contentType ? contentType : 'application/json',
                    'Accept-Language': localStorage.getItem("language") || "en-US"
                };
                return axios.post(url, data, { headers });
            }
        });
    }

    static put(url: string, data: any, contentType?: string) {
        return auth.getAccessToken().then((userToken: string) => {
            const headers = {
                'Authorization': `Bearer ${userToken}`,
                'Content-Type': contentType ? contentType : 'application/json',
                'Accept-Language': localStorage.getItem("language") || "en-US"
            };

            headers['RemoteUrl'] = window.location.href.split('#')[0];

            return axios.put(url, data, { headers });
        });
    }

    static delete(url: string) {
        return auth.getAccessToken().then((userToken: string) => {
            const headers = {
                'Authorization': `Bearer ${userToken}`
            };

            headers['RemoteUrl'] = window.location.href.split('#')[0];

            return axios.delete(url, { headers });
        });
    }

    static getFile(url: string, data: any, contentType?: string): any {
        return auth.isLoggedIn().then((isLoggedIn) => {
            if (isLoggedIn) {
                return auth.getAccessToken().then((userToken: string) => {
                    const headers = {
                        'Authorization': `Bearer ${userToken}`,
                        'Accept-Language': localStorage.getItem("language") || "en-US",
                        'Content-Type': contentType ? contentType : 'application/octet-stream',
                        'Access-Control-Expose-Headers': 'Content-Disposition,Original-File'
                    };

                    headers['RemoteUrl'] = window.location.href.split('#')[0];

                    return axios.get(url, { headers, responseType: 'arraybuffer' })
                    .then((resp: any) => {
                        if (resp.headers && resp.headers["original-file"]) {
                            let binary = atob(resp.headers["original-file"]);

                            const bytes = new Uint8Array(binary.length);
                            for (let i = 0; i < bytes.length; i++) {
                                bytes[i] = binary.charCodeAt(i);
                            }

                            let decodedString = new TextDecoder().decode(bytes);
                            resp.headers["original-file"] = decodedString;
                        }

                        return resp;
                    })
                    .catch(e => {
                        if (e.response.status === 401 || e.response.status === 403) {
                            if (window.location.pathname != "/Unauthorized")
                                window.location.href = "/Unauthorized";
                        } else {
                            return Promise.reject(e);
                        }
                    });
                });
            } else {
                const headers = {
                    'Accept-Language': localStorage.getItem("language") || "en-US",
                    'Content-Type': contentType ? contentType : 'application/octet-stream',
                    'Access-Control-Expose-Headers': 'Content-Disposition,Original-File'
                };
                return axios.get(url, { headers, responseType: 'arraybuffer' })
                .then((resp: any) => {
                    if (resp.headers && resp.headers["original-file"]) {
                        let binary = atob(resp.headers["original-file"]);

                        const bytes = new Uint8Array(binary.length);
                        for (let i = 0; i < bytes.length; i++) {
                            bytes[i] = binary.charCodeAt(i);
                        }

                        let decodedString = new TextDecoder().decode(bytes);
                        resp.headers["original-file"] = decodedString;
                    }

                    return resp;
                })
                .catch(e => {
                    if (e.response.status === 401 || e.response.status === 403) {
                        if (window.location.pathname != "/Unauthorized")
                            window.location.href = "/Unauthorized";
                    } else {
                        return Promise.reject(e);
                    }
                });
            }
        });
    }
}